








import Vue from 'vue'
export default Vue.extend({
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: ''
        },
        timeout: {
            type: Number,
            default: 2000
        },
        type: {
            type: String,
            default: 'success'
        }
    },
    methods: {
        close(error: boolean): void {
            this.$emit('close')
        },
        pop(): void {
            setTimeout(this.close, this.timeout)
        }
    },
    watch: {
        isOpen(value: boolean): void {
            if (value === true) {
                this.pop()
            }
        }
    }
})
